var map = {
	"./JCB.png": "gArA",
	"./MASTER.png": "9t1o",
	"./VISA.png": "fdsS"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "XGaQ";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/credit ^\.\/.*\.png$
// module id = XGaQ
// module chunks = 1